import { SelectedMenu, MenuTypes, MenuColor } from './types'

export function selectedMenu(payload: SelectedMenu) {
    return {
        type: MenuTypes.SELECTED_MENU,
        payload,
    }
}

export function changeColorMenu(payload: MenuColor) {
    return {
        type: MenuTypes.SET_MENU_COLOR,
        payload,
    }
}

export function initialMenu() {
    return {
        type: MenuTypes.SET_MENU_TO_INITIAL,
    }
}
